var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('switch-field',{attrs:{"label":_vm.$t('Show only totals')},model:{value:(_vm.totalsOnly),callback:function ($$v) {_vm.totalsOnly=$$v},expression:"totalsOnly"}})}
var staticRenderFns = []

export { render, staticRenderFns }